import { render, staticRenderFns } from "./ErpcSection.vue?vue&type=template&id=0b8af403&scoped=true"
import script from "./ErpcSection.vue?vue&type=script&lang=ts"
export * from "./ErpcSection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8af403",
  null
  
)

export default component.exports